import { Dispatch } from 'redux'
import {
  add as addAction,
  deleteFolder as deleteFolderAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/document-admin/actions'
import { Payload } from 'states/dux/document-admin/types'
import { Action } from 'states/types'
import { NivosFolder } from 'types/nivos-folder'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (folders: NivosFolder[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: folders
      })
    )
}

const update = (folder: NivosFolder): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [folder]
      })
    )
}

const add = (folder: NivosFolder): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [folder]
      })
    )
}

const deleteFolder = (folder: NivosFolder): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      deleteFolderAction({
        loading: false,
        data: [folder]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (folders: NivosFolder[]) => DispatchAction
  add: (folder: NivosFolder) => DispatchAction
  deleteFolder: (folder: NivosFolder) => DispatchAction
  update: (folder: NivosFolder) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  deleteFolder,
  update,
  loading
}

export { operations, set }
